export const Behavior = {
  HANDLE: 0,
  CONTEXT: 1,
};

export default {
  Behavior,
};
